export default {"src":"/_next/static/media/newsletter-img.a74d6fe4.svg","height":344,"width":530};